const initialRoomParams = { adults: 0, children: 0 };
const adultsParam = 'Adults';
const childrenParam = 'ChildrenAges';
const childrenAgesSeparator = '-';

const hasChildren = (room) => Array.isArray(room.kids) && room.kids.length > 0;

const parseChildrenAges = (room) =>
    room.kids.reduce((ages, kidAge) => `${ages}${childrenAgesSeparator}${kidAge}`, '').replace(childrenAgesSeparator, '');

const parseRoomParamsMap = (roomsParams, room, index) => {
    if (room.adults) {
        roomsParams[`room${index}${adultsParam}`] = room.adults;
    }

    if (hasChildren(room)) {
        roomsParams[`room${index}${childrenParam}`] = parseChildrenAges(room);
    }
    return roomsParams;
};

export const HotelStandaloneRoomParams = {
    compose(rooms = []) {
        const parsedRooms = rooms.reduce(parseRoomParamsMap, { ...initialRoomParams });
        return Object.keys(parsedRooms)
            .filter((keyParams) => parsedRooms[keyParams] !== 0)
            .reduce((hashParams, keyParams) => `${hashParams};${keyParams}=${parsedRooms[keyParams]}`, '');
    }
};
